import { useParams } from "react-router-dom";

interface PayrollParams {
  payrollId: string;
  entryId: string;
}

export const usePayrollParams = () => useParams() as Readonly<PayrollParams>;
